import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'ea-icon',
	templateUrl: './svg-icon.component.html',
	styleUrls: ['./svg-icon.component.scss']
})
export class SVGIconComponent {
	@Input() name: string;
	@Input() tooltipText = '';
	@Input() hasMargin = true;
	@Output() readonly iconClick = new EventEmitter<void>();

    onIconClick(): void {
        this.iconClick.emit();
    }
}
